import { dashboardRoute } from './dashboard';

export const allDashboardRoutes = [dashboardRoute()];
